import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, FormRecord, ReactiveFormsModule } from '@angular/forms';
import { from, Observable } from 'rxjs';
import { FormBuilderHelper } from '../../shared/helpers/formbuilder.helper';
import { LabelService } from '../../shared/services/label.service';
import { Filter } from '../../shared/models/filter.model';
import { FilterOption } from '../../shared/interfaces/filteroption.interface';
import { EventBus } from '../../shared/utils/eventbus';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { ResetFormComponent } from '../resetForm/reset.form.component';
import { FilterComponent } from '../filter/filter.component';
import { ShowResultsComponent } from '../showResults/showresults.component';

@Component({
  selector: 'app-filter-container',
  templateUrl: 'filter.container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgIf,
    ReactiveFormsModule,
    ResetFormComponent,
    NgFor,
    FilterComponent,
    ShowResultsComponent,
    AsyncPipe,
  ],
})
export class FilterContainerComponent implements OnInit, AfterViewInit {
  FILTER_HEADER: string;
  form?: FormRecord<FormRecord<FormControl<boolean>>>;
  currentFilter: Filter[] = [];

  @Input() filters: Observable<Filter[]> = from([]);
  @Input() items: Observable<object[]> = from([]);
  @Output() filterUpdated = new EventEmitter();
  @Output() resetFilter = new EventEmitter();

  /**
   *
   * @param labelService
   * @param fbHelper
   * @param eventBus
   */
  constructor(
    private labelService: LabelService,
    private fbHelper: FormBuilderHelper,
    private eventBus: EventBus,
  ) {
    this.FILTER_HEADER = labelService.getLabel('filtersTitel');
  }

  ngOnInit() {
    this.addSubscriptions();
  }

  onResetFilter(): void {
    this.resetFilter.emit();
  }

  ngAfterViewInit() {
    this.eventBus.emit('filterApp.initFilter');
  }

  /**
   * Subscribe once for initial filter state, and continuously for form changes
   */
  private addSubscriptions(): void {
    this.filters.subscribe((filters: Filter[]) => {
      this.currentFilter = filters;
      if (!this.form) {
        this.form = this.fbHelper.createFormRecordFromFilters(filters);
        this.form.valueChanges.subscribe((formValues) => {
          this.updateFilterFromFormValues(formValues);
        });
      } else {
        this.fbHelper.updateFormRecordFromFilters(filters, this.form);
      }
    });
  }

  /**
   * Trigger filter change after updating form
   * @param formValues
   */
  private updateFilterFromFormValues(
    formValues: Partial<{ [x: string]: Partial<{ [x: string]: boolean }> }>,
  ): void {
    const newFilters: Filter[] = this.currentFilter.map((filter: Filter) =>
      filter.clone(),
    );
    newFilters.forEach((filter: Filter) => {
      filter.options.forEach((option: FilterOption) => {
        const optionValue = formValues[filter.name]?.[option.name];
        if (optionValue !== undefined) {
          option.active = optionValue;
        }
      });
    });
    this.filterUpdated.emit(newFilters);
  }

  /**
   * @returns {Observable<Filter[]>}
   */
  get filters$(): Observable<Filter[]> {
    return this.filters;
  }

  /**
   * @returns {Observable<any[]>}
   */
  get items$(): Observable<object[]> {
    return this.items;
  }
}
